import { DateTime } from 'luxon';

const MILLION_DIVISOR = 1_000_000;

const formatNumber = (value: number, maximumFractionDigits: number, minimumFractionDigits = 0) =>
  Intl.NumberFormat('pt-BR', {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);

export const toMillionValue = (value: number) => value / MILLION_DIVISOR;

export const formatMtmTick = (value: number) => formatNumber(value, 2, 2);

export const formatMillionCurrencyLabel = (value: number) => `${formatNumber(toMillionValue(value), 2, 2)} mi`;

export const formatMwmTick = (value: number) => formatNumber(value, 1);

export const formatMwmLabel = (value: number) => formatNumber(value, 2);

export const shouldRenderValueLabel = (value: number) => Number(value) !== 0;

export const buildYearReferenceLines = (competences: string[]) => {
  const markers = new Map<string, string>();

  competences.forEach((competence, index) => {
    const date = DateTime.fromISO(competence);

    if (!date.isValid) {
      return;
    }

    const year = date.toFormat('yyyy');
    const isFirstCompetence = index === 0;
    const isJanuary = date.month === 1;

    if (markers.has(year) || (!isFirstCompetence && !isJanuary)) {
      return;
    }

    markers.set(year, competence);
  });

  return [...markers.entries()].map(([year, competence]) => ({ year, competence }));
};
